export const INIT_FLAG = 'INIT';
export const SUCCESS_FLAG = 'SUCCESS';
export const FAIL_FLAG = 'FAIL';

export const LIST_MARKUP = {
    params: {},
    isLoading: false,
    isLoaded: false,
    elements: [],
    meta: undefined,
    error: false,
};

export const ELEMENT_MARKUP = {
    params: {},
    isLoading: false,
    isLoaded: false,
    data: null,
    error: false,
};